const VisPageLogin = () => import('@/views/vis-page-login');

export default [
  {
    path: "/login",
    name: "login",
    component: VisPageLogin,
    props: route => ({ state: route.query.state })
  }
]
